<template>
  <div class="louFeng-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入确认码" v-model.number="params.confirmCode" clearable size="small" class="param-input">
      </el-input>
      <el-input placeholder="请输入用户Id" v-model.number="params.uid" clearable size="small" class="param-input">
      </el-input>
      <el-input placeholder="请输入商家Id" v-model.number="params.merchantId" clearable size="small" class="param-input">
      </el-input>
      <el-select placeholder="是否使用" v-model="params.isUse" size="small" clearable style="width:200px;margin-right:5px">
        <el-option :value="true" label="已使用" key="已使用"></el-option>
        <el-option :value="false" label="未使用" key="未使用"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="getNakedChatBuyList('status')" style="margin-right: 20px">搜索
      </el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading" ref="multipleTable" height="550">
      <el-table-column prop="id" label="ID" align="center" fixed min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.uid || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="nudeChatTitle" label="裸聊标题" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.nudeChatTitle }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="serviceName" label="服务名称" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.serviceName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="merchantId" label="商家Id" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.merchantId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="confirmCode" label="确认码" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.confirmCode || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isUse" label="是否使用" align="center" min-width="100">
        <template slot-scope="scope">
          <el-button v-if="scope.row.isUse" size="small" type="success" disabled>已使用</el-button>
          <el-button v-else size="small" type="warning" @click="confirmUseCode(scope.row)">未使用</el-button>
          <!-- <span>{{ scope.row.isUse ? "已使用" : "未使用" }}</span> -->
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作者" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.operator }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="修改时间" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="params.pageNumber" :page-size="params.pageSize"
                   layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10"
                   @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
  </div>
</template>

<script>
import API from "@/api";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      // 系统管理列表请求参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        uid: '',
        merchantId: '',//商家ID
        confirmCode: '',//确认码
        isUse: undefined,//是否使用
      },
      dialogVisible: false
    };
  },
  components: {},
  created() {
    this.getNakedChatBuyList();
  },
  methods: {
    // 请求列表
    getNakedChatBuyList(type) {
      this.loading = true;
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getNakedChatBuyList(this.params)
          .then((res) => {
            if (res.code === 200 && res.data) {
              this.tableData = res.data.list;
              this.total = res.data.total;
            } else {
              this.tableData = [];
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    confirmUseCode(row) {
      this.$confirm('确认该裸聊已使用？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const params = Object.assign({}, {
          id: row.id,
        })
        API.confirmUseCode(params).then(res => {

          if (res.code === 200) {
            this.$message({
              message: '确认成功',
              type: 'success'
            });
          this.getNakedChatBuyList()
          } else {
            this.$message.error('确认失败！');
          }
        })
        .catch(() => {
          this.flag = false
          this.getNakedChatBuyList()
          this.$message.error('确认失败！')
        })
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size;
      this.getNakedChatBuyList();
    },
    // 分页页码改变回掉
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getNakedChatBuyList();
    }
  },
};
</script>

<style lang="scss" scoped>
.payMethod {
  .add-input {
    margin-left: 0 !important;
  }
}
</style>
